import * as t from 'io-ts'

import * as tv from '@espoon-voltti/ts-libs/lib/io-ts-types'

export const RejectedDecision = t.type(
  {
    decision: t.literal('REJECTED')
  },
  'RejectedDecision'
)
export type RejectedDecision = t.TypeOf<typeof RejectedDecision>

export const PayImmediatelyDecision = t.type(
  {
    decision: t.literal('GRANTED_PAY_IMMEDIATELY'),
    amountInCents: tv.euroCentsFromNumber
  },
  'PayImmediatelyDecision'
)
export type PayImmediatelyDecision = t.TypeOf<typeof PayImmediatelyDecision>

export const PayImmediatelyWaitReportDecision = t.type(
  {
    decision: t.literal('GRANTED_PAY_IMMEDIATELY_WAIT_REPORT'),
    amountInCents: tv.euroCentsFromNumber,
    reportDeadlineDate: tv.localDateFromString
  },
  'PayImmediatelyWaitReportDecision'
)
export type PayImmediatelyWaitReportDecision = t.TypeOf<
  typeof PayImmediatelyWaitReportDecision
>

export const PayAfterReportDecision = t.type(
  {
    decision: t.literal('GRANTED_PAY_AFTER_REPORT'),
    amountInCents: tv.euroCentsFromNumber,
    reportDeadlineDate: tv.localDateFromString
  },
  'PayAfterReportDecision'
)
export type PayAfterReportDecision = t.TypeOf<typeof PayAfterReportDecision>

export type ApprovedDecision =
  | PayImmediatelyDecision
  | PayImmediatelyWaitReportDecision
  | PayAfterReportDecision
